<template>
    <info-screen
            class="startRegistration"
            :title="$ml.get('setBirthdayTitleReg')"
            :text="$ml.get('setBirthdayTextReg')"
            :action="nextScreen"
            :buttonText="nextBtnTitle"
            :titleH1="false"
            :headerImg="2"
    >
        <template slot="bottom">
            <div class="left">
                <custom-button
                        :button-text="$ml.get('back')"
                        back
                        :action="back"
                ></custom-button>
            </div>
            <div class="right">
                <custom-button
                        ref="nextBtn"
                        :button-text="nextBtnTitle"
                        success
                        :action="nextScreen"
                ></custom-button>
            </div>
        </template>
    </info-screen>

</template>

<script>
    import Profile from "../../helpers/profile";
    import InfoScreen from "../../components/layout/info-screen";
    import CustomButton from "../../components/ui/custom-button.vue";
    export default {
        name: "startSetBirthday",
        components: {InfoScreen, CustomButton},
        data(){
            return {
                nextBtnTitle: Profile.process === 'accessRecovery' ? this.$ml.get('setBirthdayButtonRecovery') : this.$ml.get('setBirthdayButtonReg')
            }
        },
        created() {
            let isMobile = window.innerWidth < 600;
            if (!isMobile) {
                if (Profile.process === 'accessRecovery')
                    this.$router.replace({ name: 'AccessRecoverySetBirthday'});
                else
                    this.$router.replace({ name: 'RegistrationSetBirthday'});
            }
        },
        methods: {
            nextScreen: function () {
                if (Profile.process === 'accessRecovery')
                    this.$router.push({ name: 'AccessRecoverySetBirthday'});
                else
                    this.$router.push({ name: 'RegistrationSetBirthday'});
            },

            back: function () {
                this.$router.back();
            },
        }

    }
</script>

<style scoped>

</style>